<template>
  <el-input
    placeholder="请输入内容"
    v-model="input"
    size="small"
    class="input-with-select"
  >
    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
  </el-input>
</template>
<script>
export default {
  data() {
    return {
      input: "",
    };
  },
  methods: {
    search() {
      if (this.input.trim() === "") {
        this.$message.error("请输入搜索内容");
        return;
      }
      // 路由跳转search页面
      this.$router.push({
        name: "search",
        query: { keyword: this.input.trim() },
      });
      this.input = "";
    },
  },
};
</script>
<style scoped>
::v-deep .el-input__inner:focus {
  outline: none;
  border-color: #dcdfe6; /* 还原为默认的边框颜色 */
  -webkit-box-shadow: none;
  box-shadow: none;
}
::v-deep .el-input__inner {
  border-right: none;
}
::v-deep .el-input-group__append {
  padding: 0 5px;
  background-color: #fff;
  border-left: none;
}
::v-deep .el-button {
  padding: 15px 4px;
}
</style>
